import { RouterState, RouterStore } from 'mobx-state-router';
import { routes } from './routes';
import { observable, action } from "mobx";
import AcProjectStore from "stores/acproject.store";
import ProjectStore from "stores/project.store";
import UserStore from "stores/user.store";
import OptionsStore from "stores/options.store";
import CampaignsStore from "stores/campaigns.store";
import CampaignStore from 'stores/campaign.store';
import UIStore from "stores/ui.store";
import AccountsStore from "stores/accounts.store";
import PrivateNetworksStore from "stores/privatenetworks.store";
import PrivateNetworkStore from "stores/privatenetwork.store";
import LinksStore from 'stores/links.store';
import XWizardStore from 'stores/xwizard.store';
import XWizardsStore from 'stores/xwizards.store';
import StrategyStore from 'stores/strategy.store';
import StrategiesStore from 'stores/strategies.store';
import IndexerProjectStore from 'stores/indexerproject.store';
import PrivateProjectStore from 'stores/privateproject.store';
import ContentGroupsStore from 'stores/contentgroups.store';
import ContentGroupStore from 'stores/contentgroup.store';
import ArticleStore from 'stores/article.store';
import EmailStore from 'stores/email.store';
import SiteSelectionsStore from 'stores/siteselections.store';
import SiteSelectionStore from 'stores/siteselection.store';
import CustomSitesStore from 'stores/customsites.store';
import CloudAccountsStore from 'stores/cloudAccounts.store';

const notFound = new RouterState('notFound');

export class RootStore {
    routerStore = new RouterStore(this, routes, notFound);    
    acProjectStore = new AcProjectStore();
    projectStore = new ProjectStore();
    privateProjectStore = new PrivateProjectStore();
    userStore = new UserStore(this);
    optionsStore = new OptionsStore();
    campaignsStore = new CampaignsStore();
    campaignStore = new CampaignStore();
    uiStore = new UIStore();
    accountsStore = new AccountsStore();
    linksStore = new LinksStore();
    xwizardStore = new XWizardStore(this);
    xwizardsStore = new XWizardsStore();
    strategyStore = new StrategyStore();
    strategiesStore = new StrategiesStore();
    indexerProjectStore = new IndexerProjectStore();
    contentGroupsStore = new ContentGroupsStore();
    contentGroupStore = new ContentGroupStore();
    articleStore = new ArticleStore();
    privateNetworksStore = new PrivateNetworksStore();
    privateNetworkStore = new PrivateNetworkStore();    
    emailStore = new EmailStore();
    siteSelectionsStore = new SiteSelectionsStore();
    siteSelectionStore = new SiteSelectionStore();
    customSitesStore = new CustomSitesStore();
    cloudAccountsStore = new CloudAccountsStore();
}